package com.ai.mitra.presentation.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.ai.mitra.di.AdMobBanner
import com.ai.mitra.theme.lightBackgroundColor
import com.ai.mitra.theme.whiteColor
import mitra.composeapp.generated.resources.*
import org.jetbrains.compose.resources.painterResource

@Composable
fun WelcomeScreen() {
    Column(
        Modifier.fillMaxSize().background(lightBackgroundColor),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Image(painter = painterResource(Res.drawable.logo), contentDescription = "logo")
        Text(
            "Welcome To Mitra",
            
            fontSize = 32.sp,
            fontWeight = FontWeight.ExtraBold, color = whiteColor,
            textAlign = TextAlign.Center
        )
        Text(
            "Experience the power of AI",
            
            fontSize = 20.sp,
            fontWeight = FontWeight.ExtraBold, color = whiteColor,
            textAlign = TextAlign.Center
        )

        /*LazyRow(
            modifier = Modifier.padding(top = 20.dp),
            horizontalArrangement = Arrangement.spacedBy(20.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            item {
                Image(
                    painter = painterResource(Res.drawable.jetpack),
                    contentDescription = "jetpack"
                )
            }
            item {
                Image(
                    painter = painterResource(Res.drawable.android),
                    contentDescription = "Android"
                )
            }
            item {
                Image(
                    painter = painterResource(Res.drawable.apple),
                    contentDescription = "iOS",
                )
            }
            item {
                Image(
                    painter = painterResource(Res.drawable.java),
                    contentDescription = "Desktop",
                )
            }
            item {
                Image(
                    painter = painterResource(Res.drawable.wasm),
                    contentDescription = "Web",
                )
            }
        }*/
    }
}